(() => {
  const guideCache = new Map();

  function getGuide(element) {
    return element ? element.closest('[data-tb-size-guide]') : null;
  }

  function shopifyRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  async function loadRenderedGuide(pageHandle, selector) {
    const cacheKey = `${pageHandle}:${selector}`;
    if (guideCache.has(cacheKey)) return guideCache.get(cacheKey);

    const root = shopifyRoot();
    const url = `${root}pages/${pageHandle}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error(`Unable to load ${url}: ${response.status}`);
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const guide = doc.querySelector(selector);

    if (!guide) {
      throw new Error(`Selector ${selector} was not found on ${url}`);
    }

    const content = guide.outerHTML;
    guideCache.set(cacheKey, content);
    return content;
  }

  async function openSizeGuide(trigger) {
    const pageHandle = trigger.dataset.sizeGuidePage;
    const selector = trigger.dataset.sizeGuideSelector;
    if (!pageHandle || !selector) return;

    trigger.classList.add('is-loading');
    trigger.setAttribute('aria-busy', 'true');

    try {
      const content = await loadRenderedGuide(pageHandle, selector);
      trigger.dispatchEvent(new CustomEvent('tooltip:open', {
        detail: { context: 'size-chart', content },
        bubbles: true
      }));
    } catch (error) {
      console.error('[Threadbare size guide]', error);
      trigger.dispatchEvent(new CustomEvent('tooltip:open', {
        detail: {
          context: 'size-chart',
          content: '<div class="tb-size-guide__error"><p>We couldn’t load this size guide.</p></div>'
        },
        bubbles: true
      }));
    } finally {
      trigger.classList.remove('is-loading');
      trigger.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const sizeGuideTrigger = event.target.closest('[data-size-guide-trigger]');
    if (sizeGuideTrigger) {
      event.preventDefault();
      event.stopPropagation();
      openSizeGuide(sizeGuideTrigger);
      return;
    }

    const tabButton = event.target.closest('[data-tb-size-tab]');
    if (tabButton) {
      const guide = getGuide(tabButton);
      if (!guide) return;

      const target = tabButton.dataset.tbSizeTab;
      guide.querySelectorAll('[data-tb-size-tab]').forEach((button) => {
        const active = button === tabButton;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      guide.querySelectorAll('[data-tb-size-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.tbSizePanel !== target;
      });
      return;
    }

    const unitButton = event.target.closest('[data-tb-size-unit]');
    if (unitButton) {
      const guide = getGuide(unitButton);
      if (!guide) return;

      const unit = unitButton.dataset.tbSizeUnit;
      guide.dataset.unit = unit;

      guide.querySelectorAll('[data-tb-size-unit]').forEach((button) => {
        const active = button.dataset.tbSizeUnit === unit;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
  }, true);
})();
